export default __webpack_public_path__ + "static/media/orange.5fad26d0.png";